import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LibItem, UserShortInfo } from "../../types";
import ManShortSelector from "../../components/ui/shortItemSelect";
import {
  backend,
  GroupData,
  libBackend,
  RoleCreationData,
} from "../../services";
import { RootState } from "../../state/reducer";
import { toast } from "sonner";
import MultiCheckbox from "../../components/ui/multiCheckbox";

interface ModalLoaderProps {
  onSave: () => void;
  closeModal: () => void;
}

const CreateRoleModal: React.FC<ModalLoaderProps> = ({
  onSave,
  closeModal,
}) => {
  const State = useSelector((state: RootState) => state);
  const session = State.session;
  if (!session?.id) {
    return null;
  }
  const [permissions, setPermissionList] = useState<LibItem[]>([]);
  const [eventTypeList, setEventTypeList] = useState<LibItem[]>([]);
  const [formData, setFormData] = useState<RoleCreationData>({
    name: "",
    rang: 0,
    permissions: [],
    permitted_events: []
  });
  
  const closeWithSave = async () => {
    console.log("Close with save called");
    await saveAction();
    onSave(); // Передаем новое фото в callback
    closeModal(); // Закрываем модальное окно
  };

  useEffect(() => {
        libBackend.getEventTypeList().then((res) => {
          setEventTypeList(res.kinds);
        });
        libBackend.getPermissionList().then((res) => {
          setPermissionList(res.permissions)
        })
  }, []);

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiCheckboxChange = (name: string, selectedIds: number[]) => {
    setFormData((prev) => ({ ...prev, [name]: selectedIds }));
  };

  const saveAction = async () => {
    console.log("Save action called");
    return new Promise((resolve) => {
      backend
        .createRole({
          ...formData, rang: Number(formData.rang)
        })
        .then(() => {
          onSave();
          toast("Роль создана");
          resolve(1)
        })
        .catch(() => {
          toast("Ошибка создания роли");
          resolve(0)
        });
    });
  };

  return (
    <div className="creationForm">
      <div className="modalHeading">
        <h3>Создание роли</h3>
      </div>
      <form className="columnCenter">
        <div className="formField formRow">
          <label htmlFor="name">Название</label>
          <div className="fieldInput flex">
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="formField formRow">
          <label htmlFor="name">Ранг</label>
          <div className="fieldInput flex">
            <input
              type="number"
              id="rang"
              name="rang"
              value={formData.rang}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="flex formRow">
          <div className="fieldName">Используемые типы событий</div>
          <div className="fieldInput">
            <MultiCheckbox
              items={eventTypeList}
              selectedIds={formData.permitted_events || []}
              displayRveresed={formData.permitted_events?.length > 5}
              onChange={(selectedIds) =>
                handleMultiCheckboxChange("permitted_events", selectedIds)
              }
            />
          </div>
        </div>
        <div className="flex formRow">
          <div className="fieldName">Разрешенные действия</div>
          <div className="fieldInput">
            <MultiCheckbox
              items={permissions}
              selectedIds={formData.permissions || []}
              displayRveresed={true}
              onChange={(selectedIds) =>
                handleMultiCheckboxChange("permissions", selectedIds)
              }
            />
          </div>
        </div>
        {/* Кнопки действий */}
        <div className="flex between btnRow">
          <button
            className="filterButton"
            type="button"
            onClick={closeWithSave}
          >
            Сохранить
          </button>
          <button className="cancelButton" type="button" onClick={closeModal}>
            Отменить
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateRoleModal;
